import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useCopyToClipboard } from 'react-use';

interface UseCopyActionProps {
  link: string;
}

export const useCopyAction = ({ link }: UseCopyActionProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const [, copy] = useCopyToClipboard();
  const onCopy = useCallback(() => {
    if (!link) {
      enqueueSnackbar(`No job data provided`, { variant: 'error' });
      return;
    }

    copy(link.toString());
    enqueueSnackbar(`Link copied to clipboard`, { variant: 'success' });
  }, [copy, enqueueSnackbar, link]);

  return onCopy;
};
